import React from 'react';
import { Container, Box } from '@mui/material';

import { useQuery } from 'react-query';
import Header from './Header/Header.js';
import Footer from './Footer/Footer.js';
import AnnouncementBanner from '../components/AnnouncementBanner.js';
import { logo } from './Header/APIRequests.js';

const Layout = ({ children }) => {
  const { data: headerData } = useQuery('logo', logo);

  return (
    <Box display="flex" flexDirection="column" minHeight="100vh">
      {
        <AnnouncementBanner
          title={headerData?.banner?.title}
          description={headerData?.banner?.description}
        />
      }
      <Box position="relative">
        <Header />
      </Box>
      <Container maxWidth={false} sx={{ flex: 1, padding: 0 }} disableGutters>
        {children}
      </Container>
      <Footer />
    </Box>
  );
};

export default Layout;
